<div class="seek-container">
  <div *ngIf="(!isLive && !isAd && (seeking || seekingWithMouse || automaticSeek)) && currentThumbnail" class="seekbar-thumbnails">
    <div [ngStyle]="{'width': ((percentage > 15 ? percentage <= 85 ? percentage : 90 : 10) - 10).toString() + '%', transition: 'width 0.3s ease' }"></div>
    <div
      class="seekbar-thumbnails-item" 
      [ngStyle]="{
        'background-image': currentThumbnail?.backgroundImage,
        'background-position': currentThumbnail?.backgroundPosition,
        'background-size': currentThumbnail?.backgroundSize,
        'height': currentThumbnail?.height,
        'width': currentThumbnail?.width
      }">
    <span class="seekbar-thumbnails-item-time">{{ innerValue | secondsToTimePlayer }}</span></div>
  </div>
  <ng-container *ngIf="showCuepoints">
      <div class="cuepoint-container">
        <div *ngFor="let point of cuepoints; trackBy: trackByStartTime" class="cuepoint"  [ngClass]="{ 'ad': isAd }"
          [ngStyle]="{ left: (max | playerSeekbar: point.startTime) + '%' }"
          ></div>
      </div>
  </ng-container>
  <div class="seekbarContainer">
    <div #bar class="seekbar-bar" [ngStyle]="{ width: percentage.toString() + '%' }" [ngClass]="{ 'ad': isAd }"></div>
    <div
      id="seekbar-focusable-button"
      #button
      tabindex="0"
      class="seekbar-button focusable-element"
      [ngClass]="{ 'ad': isAd }"
      (keydown)="onKeyDown($event)"
    >
      <div class="seekbar-speed-indicator" *ngIf="speedInfo">
        <div class="seekbar-rewind-icon" *ngIf="speedInfo.direction < 0"></div>
        <div class="seekbar-speed-text"
          [ngStyle]="{'padding-left' : speedInfo.direction > 0 ? '1vw' : undefined, 'padding-right': speedInfo.direction < 0 ? '1vw' : undefined}"
        >
          {{speedInfo.speed}}
        </div>
        <div class="seekbar-forward-icon" *ngIf="speedInfo.direction > 0"></div>
      </div>
    </div>
  </div>
</div>